import React, { useEffect, useState } from 'react';
import { translate } from '../../../Services/translation';
import { BCAddressItem } from '../BCAddressItem';
import { BCTabContainer } from './BCTabContainer';
import { useBCApi } from '../hooks/BCApi';
import constants from '../../../constants';
import Modal from 'react-modal';

const addressTypes = {
    Delivery: 'Delivery',
    Billing: 'Billing',
    Address: 'Address',
    AlternativeAddress: 'AlternativeAddress',
    BillingAndDelivery: 'BillingAndDelivery',
};

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: 'fit-content',
        height: 'fit-content',
        borderRadius: '20px',
    },
};

export const Addresses = () => {
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [showAddAddress, setShowAddAddress] = useState(false);

    const { status, value, error, execute } = useBCApi(
        '/api/bcmypages/addresses',
        true
    );

    const deleteRequest = useBCApi(`/api/bcmypages/addresses`);
    const createRequest = useBCApi(`/api/bcmypages/addresses`);

    useEffect(() => {
        if (deleteRequest.status === 'success') {
            execute();
        }
    }, [deleteRequest.status, execute]);

    useEffect(() => {
        if (createRequest.status === 'success') {
            setShowAddAddress(false);
            execute();
        }
    }, [createRequest.status, execute]);

    return (
        <>
            <BCTabContainer title={translate('business.addressestab.header')}>
                <div className="BusinessCentral__AddressesTab__container__content">
                    <div>
                        <h2 className="BusinessCentral__AddressesTab__container__content__title">
                            {translate('business.addressestab.title.delivery')}
                        </h2>
                        {value?.addresses?.length > 0 &&
                            value?.addresses.map((address, idx) => {
                                return (
                                    <BCAddressItem
                                        onDelete={() => {
                                            setSelectedAddress(address);
                                        }}
                                        key={idx}
                                        address={address}
                                        showButtons={true}
                                        fetch={() => execute()}
                                    />
                                );
                            })}
                        {showAddAddress && (
                            <BCAddressItem
                                createRequest={createRequest}
                                createForm={true}
                                fetch={() => execute()}
                                address={{
                                    address: '',
                                    address2: '',
                                    addressType: addressTypes.Delivery,
                                    city: '',
                                    country: constants.countries[0].value,
                                    phoneNumber: '',
                                    zipCode: '',
                                }}
                                showButtons={value?.isOrderApprover}
                                onDelete={() => {
                                    setShowAddAddress(!showAddAddress);
                                }}
                            />
                        )}

                        <button
                            className="BusinessCentral__AddressesTab__container__content__button"
                            onClick={() => setShowAddAddress(true)}
                            disabled={showAddAddress}
                        >
                            <p>
                                {translate('business.addressestab.button.text')}
                            </p>
                        </button>
                    </div>
                    <div>
                    </div>
                </div>
            </BCTabContainer>
            <Modal
                ariaHideApp={false}
                preventScroll={false}
                isOpen={selectedAddress !== null}
                onRequestClose={() => setSelectedAddress(null)}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
            >
                <h2>{translate('business.addressestab.modal.remove.title')}</h2>
                <p>
                    {translate('business.addressestab.modal.remove.text')}{' '}
                    {selectedAddress?.address}
                </p>
                <div className="BCConfirmModal__buttons">
                    <button
                        className="BCConfirmModal__buttons__button"
                        onClick={() => setSelectedAddress(null)}
                    >
                        {translate('business.addressestab.modal.remove.cancel')}
                    </button>
                    <button
                        className="BCConfirmModal__buttons__button"
                        onClick={() => {
                            deleteRequest.execute(
                                'DELETE',
                                selectedAddress?.systemId
                            );
                            setSelectedAddress(null);
                        }}
                    >
                        {translate(
                            'business.addressestab.modal.remove.confirm'
                        )}
                    </button>
                </div>
            </Modal>
        </>
    );
};
